<div fxLayout="column" class="neq-dialog">
    <div class="message" innerText="{{message}}"></div>
    
    <mat-form-field *ngIf="type === 'input-text'">
        <input type="text" matInput
            [formControl]="inputControl"
            [(ngModel)]="response">
        <mat-error *ngIf="!inputControl.valid">{{getTooltipErrorMessage()}}</mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="type === 'input-textarea'">
        <textarea pInputTextaera type="textarea" matInput
            [formControl]="inputControl"
            [(ngModel)]="response">
        </textarea>
        <mat-error *ngIf="!inputControl.valid">{{getTooltipErrorMessage()}}</mat-error>
    </mat-form-field>

    <div *ngIf="type === 'select'">
        <neq-select-autocomplete #select matInput
            [dataSource]="getDataSource"
            [paginatedResults]="false"
            [(ngModel)]="response"
            (change)="changeSelectedElement($event)">
        </neq-select-autocomplete>
        <mat-error *ngIf="!inputControl.valid">{{getTooltipErrorMessage()}}</mat-error>
    </div>
    
    <mat-form-field *ngIf="type === 'input-nutrient'">
        <input type="number" matInput
            [formControl]="inputControl"
            [(ngModel)]="response">
        <mat-error *ngIf="!inputControl.valid">{{getTooltipErrorMessage()}}</mat-error>
    </mat-form-field>

    <div class="asi-container" fxLayout="row" fxLayoutAlign="center center">
        <button pButton class="neq-primeng-button-text"
              [label]="'msg.common.validation.overwrite' | translate" (click)="checkInput(false)"></button>
        <button *ngIf="type === 'input-textarea'" pButton class="neq-primeng-button-text"
              [label]="'msg.common.validation.add' | translate" (click)="checkInput(true)"></button>
        <button pButton class="neq-primeng-button-text"
              [label]="'msg.common.validation.cancel' | translate" [mat-dialog-close]="false"></button>
    </div>
</div>